module.exports = { "default": require("core-js/library/fn/string/from-code-point"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/string/from-code-point.js